import type { FormKitNode } from '@formkit/core'

export default (block: ScrollLogicalPosition = 'center') => (node: FormKitNode) => {
  const scrollTo = (node: FormKitNode): void => 
    document.getElementById(node.props.id as string)?.scrollIntoView({ behavior: 'smooth', block, inline: 'nearest' })
  
  const scrollToErrors = (): void => {
    node.walk(child => {
      if ((child.ledger.value('blocking') || child.ledger.value('errors'))) {
        scrollTo(child)
        return false
      }
    }, true)
  }
  
  const onSubmitInvalid = node.props.onSubmitInvalid
  node.props.onSubmitInvalid = () => {
    onSubmitInvalid?.(node)
    scrollToErrors()
  }

  node.on('unsettled:errors', scrollToErrors)
}